import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "rydecast_session_id";

export const getSessionId = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = window.crypto?.randomUUID?.() || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

export const trackPage = (path) => {
  axios
    .post(`${API}/track`, {
      path,
      referrer: document.referrer,
      session_id: getSessionId(),
    })
    .catch(() => {});
};

export const trackEvent = (event, label = "", path = window.location.pathname) => {
  const payload = JSON.stringify({
    event,
    label: String(label).replace(/\s+/g, " ").trim().slice(0, 160),
    path,
    session_id: getSessionId(),
  });

  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/track-event`, new Blob([payload], { type: "application/json" }));
      return;
    }
  } catch {}

  axios.post(`${API}/track-event`, JSON.parse(payload)).catch(() => {});
};
